
import Vue from 'vue';

import * as UIStore from '@/store/search/ui';
import * as PatternStore from '@/store/search/form/patterns';
import * as CorpusStore from '@/store/search/corpus';

import { Option } from '@/components/SelectPicker.vue';
import { corpusCustomizations } from '@/store/search/ui';

export default Vue.extend({
	computed: {
		withinOptions(): Option[] {
			const {enabled, elements} = UIStore.getState().search.shared.within;
			return enabled ? elements.filter(element => corpusCustomizations.search.within.includeSpan(element.value)) : [];
		},
		within: {
			get(): string|null {
				return PatternStore.getState().shared.within;
			},
			set(v: string|null) {
				PatternStore.actions.shared.within(v);;
			}
		},
	},
	methods: {
		withinAttributes(): Option[] {
			const within = this.within;
			if (!within) return [];

			const option = this.withinOptions.find(o => o.value === within);
			if (!option) return [];

			return (corpusCustomizations.search.within._attributes(option.value) || [])
				.map(el => typeof el === 'string' ? { value: el } : el);
		},
		withinAttributeValue(option: Option) {
			if (this.within === null)
			 	return '';
			const within = PatternStore.getState().shared.withinAttributes;
			return within ? within[option.value] ?? '' : '';
		},
		changeWithinAttribute(option: Option, event: Event) {
			const spanName = this.within;
			if (spanName === null)
				return;
			const el = event.target as HTMLInputElement;
			const curVal = PatternStore.getState().shared.withinAttributes || {};
			curVal[option.value] = el.value;
			PatternStore.actions.shared.withinAttributes(curVal);
		},
	},
})
